import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-504b44fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mind-games-header" }
const _hoisted_2 = { class: "mind-games-header__headline" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mind-games-header__headline-separator" }, null, -1))
const _hoisted_4 = { class: "mind-games-header__headline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header__container",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
    }, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.mindScrambler.currentWord), 1),
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.gamesScrambler.currentWord), 1)
    ])
  ]))
}